export default "__VITE_ASSET__CxsUSpgj__"